import { SITE_HOME } from '@/utils/previewRoutes';

export const FOOTER_ABOUT_FULL = {
  title: 'About Hireclap',
  paragraphs: [
    'Hireclap is India\'s video-resume job platform for freshers and entry-level hiring. Over 3 million jobseekers and 5,000+ companies use Hireclap to discover roles, post jobs, and hire at scale.',
    'Jobseekers post a 2-minute Visume to stand out beyond a PDF resume. Employers post jobs for free, screen video profiles, and run campus and recruitment campaigns with structured hiring tools.',
  ],
};

export const FOOTER_ABOUT_SLIM = {
  title: 'About Hireclap',
  paragraphs: [
    'Hireclap helps freshers find entry-level jobs with a 2-minute Visume video profile. Employers post jobs and hire from a large career-intent fresher community.',
  ],
};

const HELP_ZONE = {
  id: 'help',
  title: 'Need help?',
  links: [
    { href: 'mailto:recruit@hireclap.com', label: 'recruit@hireclap.com' },
  ],
  phone: '+91 9037 156 256',
  cta: { href: '/contact-us', label: 'Contact Us' },
};

const CANDIDATE_ZONE = {
  id: 'candidates',
  title: 'Candidate zone',
  links: [
    { href: '/jobseeker/register', label: 'Post visume' },
    { href: SITE_HOME, label: 'Candidate services' },
  ],
};

const EMPLOYER_ZONE = {
  id: 'employers',
  title: 'Employer zone',
  links: [
    { href: '/recruit/post-job', label: 'Free job posting' },
    { href: 'https://recruit.hireclap.com/', label: 'Recruitment Services', external: true },
    { href: 'https://campus.hireclap.com/', label: 'Campus Recruitment', external: true },
    { href: 'https://www.assessengine.com/', label: 'Online assessment', external: true, featured: true },
  ],
};

const INSTITUTE_ZONE = {
  id: 'institutes',
  title: 'Institute zone',
  links: [
    { href: '/institutes', label: 'List your institute' },
    { href: 'https://edtech.hireclap.com/', label: 'Edtech marketing', external: true },
  ],
};

const COLLEGE_ZONE = {
  id: 'colleges',
  title: 'College zone',
  links: [
    { href: '/colleges/register', label: 'List your college' },
    { href: 'https://campus.hireclap.com/', label: 'Campus placements', external: true },
    { href: '/', label: 'Placement preparation' },
    { href: '/', label: 'Mock assessments' },
  ],
};

export const FOOTER_ZONES_FULL = [
  HELP_ZONE,
  CANDIDATE_ZONE,
  EMPLOYER_ZONE,
  INSTITUTE_ZONE,
  COLLEGE_ZONE,
];

export const FOOTER_ZONES_SLIM = [
  HELP_ZONE,
  CANDIDATE_ZONE,
  EMPLOYER_ZONE,
  INSTITUTE_ZONE,
  COLLEGE_ZONE,
];

/** @deprecated use FOOTER_ZONES_FULL */
export const FOOTER_ZONES = FOOTER_ZONES_FULL;

export const FOOTER_SOCIAL = [
  { href: 'https://www.facebook.com/Hireclap', label: 'Facebook', icon: 'facebook' },
  { href: 'https://twitter.com/hireclap', label: 'Twitter', icon: 'twitter' },
  { href: 'https://www.linkedin.com/company/hireclap', label: 'LinkedIn', icon: 'linkedin' },
  { href: 'https://www.youtube.com/channel/UC_Rhjfe3TniDTGLn8nxcu0Q', label: 'YouTube', icon: 'youtube' },
  { href: 'https://www.instagram.com/hireclap', label: 'Instagram', icon: 'instagram' },
];

export const FOOTER_SEO_SECTIONS = [
  {
    "id": "cities",
    "title": "Jobs by city",
    "indexHref": "/jobs-by-cities",
    "primaryCount": 16,
    "links": [
      {
        "href": "/jobs-in-ahmedabad",
        "label": "Jobs in Ahmedabad"
      },
      {
        "href": "/jobs-in-hyderabad",
        "label": "Jobs in Hyderabad"
      },
      {
        "href": "/jobs-in-pune",
        "label": "Jobs in Pune"
      },
      {
        "href": "/jobs-in-lucknow",
        "label": "Jobs in Lucknow"
      },
      {
        "href": "/jobs-in-bangalore",
        "label": "Jobs in Bangalore"
      },
      {
        "href": "/jobs-in-kolkata",
        "label": "Jobs in Kolkata"
      },
      {
        "href": "/jobs-in-gurgaon",
        "label": "Jobs in Gurgaon"
      },
      {
        "href": "/jobs-in-bhopal",
        "label": "Jobs in Bhopal"
      },
      {
        "href": "/jobs-in-chennai",
        "label": "Jobs in Chennai"
      },
      {
        "href": "/jobs-in-kochi",
        "label": "Jobs in Kochi"
      },
      {
        "href": "/jobs-in-noida",
        "label": "Jobs in Noida"
      },
      {
        "href": "/jobs-in-indore",
        "label": "Jobs in Indore"
      },
      {
        "href": "/jobs-in-delhi",
        "label": "Jobs in Delhi"
      },
      {
        "href": "/jobs-in-mumbai",
        "label": "Jobs in Mumbai"
      },
      {
        "href": "/jobs-in-jaipur",
        "label": "Jobs in Jaipur"
      },
      {
        "href": "/jobs-in-patna",
        "label": "Jobs in Patna"
      },
      {
        "href": "/jobs-in-nagpur",
        "label": "Jobs in Nagpur"
      },
      {
        "href": "/jobs-in-meerut",
        "label": "Jobs in Meerut"
      },
      {
        "href": "/jobs-in-mysore",
        "label": "Jobs in Mysore"
      },
      {
        "href": "/jobs-in-vadodara",
        "label": "Jobs in Vadodara"
      },
      {
        "href": "/jobs-in-warangal",
        "label": "Jobs in Warangal"
      },
      {
        "href": "/jobs-in-gwalior",
        "label": "Jobs in Gwalior"
      },
      {
        "href": "/jobs-in-udaipur",
        "label": "Jobs in Udaipur"
      },
      {
        "href": "/jobs-in-rajkot",
        "label": "Jobs in Rajkot"
      },
      {
        "href": "/jobs-in-salem",
        "label": "Jobs in Salem"
      },
      {
        "href": "/jobs-in-coimbatore",
        "label": "Jobs in Coimbatore"
      },
      {
        "href": "/jobs-in-visakhapatnam",
        "label": "Jobs in Visakhapatnam"
      },
      {
        "href": "/jobs-in-bhubaneswar",
        "label": "Jobs in Bhubaneswar"
      },
      {
        "href": "/jobs-in-nellore",
        "label": "Jobs in Nellore"
      },
      {
        "href": "/jobs-in-surat",
        "label": "Jobs in Surat"
      },
      {
        "href": "/jobs-in-kottayam",
        "label": "Jobs in Kottayam"
      },
      {
        "href": "/jobs-in-vijayawada",
        "label": "Jobs in Vijayawada"
      },
      {
        "href": "/jobs-in-jodhpur",
        "label": "Jobs in Jodhpur"
      },
      {
        "href": "/jobs-in-chandigarh",
        "label": "Jobs in Chandigarh"
      },
      {
        "href": "/jobs-in-kanpur",
        "label": "Jobs in Kanpur"
      },
      {
        "href": "/jobs-in-srinagar",
        "label": "Jobs in Srinagar"
      },
      {
        "href": "/jobs-in-mangalore",
        "label": "Jobs in Mangalore"
      },
      {
        "href": "/jobs-in-nasik",
        "label": "Jobs in Nasik"
      },
      {
        "href": "/jobs-in-varanasi",
        "label": "Jobs in Varanasi"
      },
      {
        "href": "/jobs-in-vellore",
        "label": "Jobs in Vellore"
      },
      {
        "href": "/jobs-in-amritsar",
        "label": "Jobs in Amritsar"
      },
      {
        "href": "/jobs-in-ranchi",
        "label": "Jobs in Ranchi"
      },
      {
        "href": "/jobs-in-guwahati",
        "label": "Jobs in Guwahati"
      },
      {
        "href": "/jobs-in-kota",
        "label": "Jobs in Kota"
      },
      {
        "href": "/jobs-in-jalandhar",
        "label": "Jobs in Jalandhar"
      },
      {
        "href": "/jobs-in-thiruvananthapuram",
        "label": "Jobs in Thiruvananthapuram"
      },
      {
        "href": "/jobs-in-jabalpur",
        "label": "Jobs in Jabalpur"
      },
      {
        "href": "/jobs-in-agra",
        "label": "Jobs in Agra"
      }
    ]
  },
  {
    "id": "categories",
    "title": "Jobs by Category",
    "indexHref": "/jobs-by-category",
    "primaryCount": 16,
    "links": [
      {
        "href": "/government-jobs-vacancies",
        "label": "Government Jobs"
      },
      {
        "href": "/sales-and-marketing-jobs-vacancies",
        "label": "Sales and Marketing Jobs"
      },
      {
        "href": "/bpo-jobs-vacancies",
        "label": "BPO Jobs"
      },
      {
        "href": "/internship-jobs-vacancies",
        "label": "Internship Jobs"
      },
      {
        "href": "/work-from-home-jobs-vacancies",
        "label": "Work from Home Jobs"
      },
      {
        "href": "/mba-jobs-vacancies",
        "label": "MBA Jobs"
      },
      {
        "href": "/walkin-jobs-vacancies",
        "label": "Walkin Jobs"
      },
      {
        "href": "/part-time-jobs-vacancies",
        "label": "Part Time Jobs"
      },
      {
        "href": "/it-software-jobs-vacancies",
        "label": "IT/Software Jobs"
      },
      {
        "href": "/management-jobs-vacancies",
        "label": "Management Jobs"
      },
      {
        "href": "/digital-marketing-jobs-vacancies",
        "label": "Digital Marketing Jobs"
      },
      {
        "href": "/core-technical-jobs-vacancies",
        "label": "Core Technical Jobs"
      },
      {
        "href": "/bank-jobs-vacancies",
        "label": "Bank Jobs"
      },
      {
        "href": "/railways-jobs-vacancies",
        "label": "Railways Jobs"
      },
      {
        "href": "/defence-jobs-vacancies",
        "label": "Defence Jobs"
      },
      {
        "href": "/finance-jobs-vacancies",
        "label": "Finance Jobs"
      },
      {
        "href": "/health-care-jobs-vacancies",
        "label": "Health Care Jobs"
      },
      {
        "href": "/computer-operator-jobs-vacancies",
        "label": "Computer Operator Jobs"
      },
      {
        "href": "/dream-jobs-5-lpa-jobs-vacancies",
        "label": "Dream Jobs/5 lpa Jobs"
      },
      {
        "href": "/scholarships-jobs-vacancies",
        "label": "Scholarships Jobs"
      },
      {
        "href": "/tech-support-jobs-vacancies",
        "label": "Tech Support Jobs"
      },
      {
        "href": "/research-jobs-vacancies",
        "label": "Research Jobs"
      },
      {
        "href": "/logistics---transportation-jobs-vacancies",
        "label": "Logistics / Transport Jobs"
      },
      {
        "href": "/diploma-jobs",
        "label": "Diploma Jobs"
      },
      {
        "href": "/1-to-3-yr-exp-jobs-vacancies",
        "label": "1 to 3 Yr Exp Jobs"
      },
      {
        "href": "/maintenance-jobs-vacancies",
        "label": "Maintenance Jobs"
      },
      {
        "href": "/startup-jobs-vacancies",
        "label": "StartUp Jobs"
      },
      {
        "href": "/bsc-bca-bbm-jobs-vacancies",
        "label": "BSc/BCA/BBM Jobs"
      },
      {
        "href": "/apprenticeship-jobs-vacancies",
        "label": "Apprenticeship Jobs"
      },
      {
        "href": "/analyst---analytics-jobs-vacancies",
        "label": "Analyst / Analytics Jobs"
      },
      {
        "href": "/hospitality-jobs-vacancies",
        "label": "Hospitality Jobs"
      },
      {
        "href": "/multimedia-jobs-vacancies",
        "label": "Multimedia Jobs"
      },
      {
        "href": "/pharma-jobs-vacancies",
        "label": "Pharma Jobs"
      },
      {
        "href": "/quality-control-jobs-vacancies",
        "label": "Quality Control Jobs"
      },
      {
        "href": "/hire-and-train-jobs-vacancies",
        "label": "Hire and Train Jobs"
      },
      {
        "href": "/retail-jobs-vacancies",
        "label": "Retail Jobs"
      },
      {
        "href": "/teaching-jobs-vacancies",
        "label": "Teaching Jobs"
      },
      {
        "href": "/manpower-consultants-jobs-vacancies",
        "label": "Manpower Consultants Jobs"
      },
      {
        "href": "/sports-jobs-vacancies",
        "label": "Sports Jobs"
      },
      {
        "href": "/office-assistant-jobs-vacancies",
        "label": "Office Assistant Jobs"
      },
      {
        "href": "/journalism-jobs-vacancies",
        "label": "Journalism Jobs"
      }
    ]
  },
  {
    "id": "roles",
    "title": "Jobs by Role",
    "indexHref": "/jobs-by-roles",
    "primaryCount": 16,
    "links": [
      {
        "href": "/it-software-engineer-jobs-vacancies",
        "label": "IT Software-Engineer Jobs"
      },
      {
        "href": "/engineer-(core,-non-it)-jobs-vacancies",
        "label": "Engineer (Core, Non-IT) Jobs"
      },
      {
        "href": "/doctor-physician-jobs-vacancies",
        "label": "Doctor / Physician Jobs"
      },
      {
        "href": "/delivery-executive-jobs-vacancies",
        "label": "Delivery Executive Jobs"
      },
      {
        "href": "/sales-marketing-executive-jobs-vacancies",
        "label": "Sales and Marketing Jobs"
      },
      {
        "href": "/customer-service-tech-support-jobs-vacancies",
        "label": "Customer Support Jobs"
      },
      {
        "href": "/nurse-healthcare-jobs-vacancies",
        "label": "Nurse / Healthcare Jobs"
      },
      {
        "href": "/pharmacist-medical-rep-jobs-vacancies",
        "label": "Medical / Pharma Jobs"
      },
      {
        "href": "/bpo-telecaller-jobs-vacancies",
        "label": "BPO / Telecaller Jobs"
      },
      {
        "href": "/hr-admin-jobs-vacancies",
        "label": "HR / Admin Jobs"
      },
      {
        "href": "/retail-store-executive-jobs-vacancies",
        "label": "Retail Executive Jobs"
      },
      {
        "href": "/receptionist-front-office-jobs-vacancies",
        "label": "Front Office Jobs"
      },
      {
        "href": "/data-entry-back-office-jobs-vacancies",
        "label": "Data Entry /Back Office Jobs"
      },
      {
        "href": "/customer-service-tech-support-jobs-vacancies",
        "label": "Teacher / Trainer Jobs"
      },
      {
        "href": "/accountant-jobs-vacancies",
        "label": "Accountant Jobs"
      },
      {
        "href": "/seo-social-media-jobs-vacancies",
        "label": "SEO / Social Media Jobs"
      },
      {
        "href": "/content-writer--jobs-vacancies",
        "label": "Content Writer Jobs"
      },
      {
        "href": "/beautician-spa-jobs-vacancies",
        "label": "Beautician / Spa Jobs"
      },
      {
        "href": "/it---mobile-developer-jobs-vacancies",
        "label": "IT - Mobile Developer Jobs"
      },
      {
        "href": "/steward-hospitality-jobs-vacancies",
        "label": "Steward / Hospitality Jobs"
      },
      {
        "href": "/it-hardware-engineer-jobs-vacancies",
        "label": "IT Hardware Engineer Jobs"
      },
      {
        "href": "/counsellor-jobs-vacancies",
        "label": "Counsellor Jobs"
      },
      {
        "href": "/design-animation-jobs-vacancies",
        "label": "Design / Animation Jobs"
      },
      {
        "href": "/architect-jobs-vacancies",
        "label": "Architect Jobs"
      },
      {
        "href": "/research-jrf-srf-jobs-vacancies",
        "label": "Research/JRF/SRF Jobs"
      },
      {
        "href": "/fashion-designer-jobs-vacancies",
        "label": "Fashion designer Jobs"
      },
      {
        "href": "/mechanic-fitter-production-jobs-vacancies",
        "label": "Fitter / Mechanic Jobs"
      },
      {
        "href": "/management-trainee-jobs-vacancies",
        "label": "Management Trainee Jobs"
      },
      {
        "href": "/chef-cook-jobs-vacancies",
        "label": "Chef / Cook Jobs"
      },
      {
        "href": "/others-jobs-vacancies",
        "label": "Others Jobs"
      },
      {
        "href": "/media-journalism-events-jobs-vacancies",
        "label": "Media & Journalism Jobs"
      }
    ]
  },
  {
    "id": "courses",
    "title": "Jobs by Course",
    "indexHref": "/jobs-by-courses",
    "primaryCount": 16,
    "links": [
      {
        "href": "/be-b-tech-jobs",
        "label": "BE/B.Tech Jobs"
      },
      {
        "href": "/msc-jobs",
        "label": "MSc Jobs"
      },
      {
        "href": "/any-graduate-jobs",
        "label": "Any Graduate Jobs"
      },
      {
        "href": "/bed-jobs",
        "label": "BEd Jobs"
      },
      {
        "href": "/mba-pgdm-jobs",
        "label": "MBA/PGDMS Jobs"
      },
      {
        "href": "/bca-jobs",
        "label": "BCA Jobs"
      },
      {
        "href": "/b-com-jobs",
        "label": "B.Com Jobs"
      },
      {
        "href": "/bba-bbm-jobs",
        "label": "BBA/BBM Jobs"
      },
      {
        "href": "/mca-jobs",
        "label": "MCA Jobs"
      },
      {
        "href": "/bsc-jobs",
        "label": "BSc Jobs"
      },
      {
        "href": "/bams-jobs",
        "label": "BAMS Jobs"
      },
      {
        "href": "/b-pharm-jobs",
        "label": "B.Pharm Jobs"
      },
      {
        "href": "/me-m-tech-jobs",
        "label": "ME/M.Tech Jobs"
      },
      {
        "href": "/diploma-jobs",
        "label": "Diploma Jobs"
      },
      {
        "href": "/ba-jobs",
        "label": "BA Jobs"
      },
      {
        "href": "/any-post-graduate-jobs",
        "label": "Any Post Graduate Jobs"
      },
      {
        "href": "/ma-jobs",
        "label": "MA Jobs"
      },
      {
        "href": "/ca-jobs",
        "label": "CA Jobs"
      },
      {
        "href": "/llb-jobs",
        "label": "LLB Jobs"
      },
      {
        "href": "/md-jobs",
        "label": "MD Jobs"
      },
      {
        "href": "/bds-jobs",
        "label": "BDS Jobs"
      },
      {
        "href": "/certificate-course-iti-jobs",
        "label": "ITI Jobs"
      },
      {
        "href": "/mds-jobs",
        "label": "MDS Jobs"
      },
      {
        "href": "/ms-jobs",
        "label": "MS Jobs"
      },
      {
        "href": "/10th-pass-ssc-jobs",
        "label": "10th Pass (SSC) Jobs"
      },
      {
        "href": "/other-post-graduate-jobs",
        "label": "Other Post Graduate Jobs"
      },
      {
        "href": "/cs-jobs",
        "label": "CS Jobs"
      },
      {
        "href": "/b-arch-jobs",
        "label": "B.Arch Jobs"
      },
      {
        "href": "/pg-diploma-jobs",
        "label": "PG Diploma Jobs"
      },
      {
        "href": "/mbbs-jobs",
        "label": "MBBS Jobs"
      },
      {
        "href": "/b-design-jobs",
        "label": "B.Design Jobs"
      },
      {
        "href": "/b-f-scfisheries-jobs",
        "label": "B.F.Sc(Fisheries) Jobs"
      },
      {
        "href": "/bhm-jobs",
        "label": "BHM Jobs"
      },
      {
        "href": "/icwa-jobs",
        "label": "ICWA Jobs"
      },
      {
        "href": "/med-jobs",
        "label": "MEd Jobs"
      },
      {
        "href": "/b-fashiontech-jobs",
        "label": "B.FashionTech Jobs"
      },
      {
        "href": "/bhms-jobs",
        "label": "BHMS Jobs"
      },
      {
        "href": "/llm-jobs",
        "label": "LLM Jobs"
      },
      {
        "href": "/m-com-jobs",
        "label": "M.Com Jobs"
      },
      {
        "href": "/b-p-ed-jobs",
        "label": "B.P.Ed Jobs"
      },
      {
        "href": "/bsw-jobs",
        "label": "BSW Jobs"
      },
      {
        "href": "/m-phil---ph-d-jobs",
        "label": "M Phil / Ph.D Jobs"
      },
      {
        "href": "/msw-jobs",
        "label": "MSW Jobs"
      },
      {
        "href": "/bfa-jobs",
        "label": "BFA Jobs"
      },
      {
        "href": "/bvsc-jobs",
        "label": "BVSc Jobs"
      },
      {
        "href": "/m-arch-jobs",
        "label": "M.Arch Jobs"
      },
      {
        "href": "/m-pharm-jobs",
        "label": "M.Pharm Jobs"
      }
    ]
  },
  {
    "id": "branches",
    "title": "Jobs by Branch",
    "indexHref": "/jobs-by-branch",
    "primaryCount": 16,
    "links": [
      {
        "href": "/be-b-tech-aeronautical-avionics-aerospace-engineering-jobs",
        "label": "Aeronautical Engineering Jobs"
      },
      {
        "href": "/be-b-tech-chemical-engineering-jobs",
        "label": "Chemical Engineering Jobs"
      },
      {
        "href": "/be-b-tech-electronics-instrumentation-engineering-jobs",
        "label": "Electronics  Instrumentation  Jobs"
      },
      {
        "href": "/10th-pass-ssc-10thpass-jobs",
        "label": "10th Pass Jobs"
      },
      {
        "href": "/be-b-tech-architecture-engineering-jobs",
        "label": "Architecture Engineering Jobs"
      },
      {
        "href": "/be-b-tech-civil-engineering-jobs",
        "label": "Civil Engineering Jobs"
      },
      {
        "href": "/be-b-tech-mechanical-engineering-jobs",
        "label": "Mechanical Engineering Jobs"
      },
      {
        "href": "/12th-pass-hse-12thpass-jobs",
        "label": "12th Pass Jobs"
      },
      {
        "href": "/be-b-tech-automobile-engineering-jobs",
        "label": "Automobile Engineering Jobs"
      },
      {
        "href": "/mba-pgdm-banking-finance-jobs",
        "label": "Banking & Finance Jobs"
      },
      {
        "href": "/bsc-nursing-jobs",
        "label": "Nursing Jobs"
      },
      {
        "href": "/bsc-information-technology-jobs",
        "label": "IT Jobs (BSc)"
      },
      {
        "href": "/be-b-tech-computer-science-engineering-cse-jobs",
        "label": "Computer Science Jobs"
      },
      {
        "href": "/be-b-tech-electrical-engineering-jobs",
        "label": "Electrical Engineering Jobs"
      },
      {
        "href": "/bsc-physics-applied-physics-jobs",
        "label": "BSC Physics Jobs"
      },
      {
        "href": "/mba-pgdm-international-marketing-jobs",
        "label": "Marketing Jobs"
      },
      {
        "href": "/ba-business-management-jobs",
        "label": "Business Management Jobs-BA"
      },
      {
        "href": "/ba-economics-jobs",
        "label": "Economics Jobs-BA"
      },
      {
        "href": "/me-m-tech-advanced-computing-jobs",
        "label": "Advanced Computing Jobs"
      },
      {
        "href": "/diploma-bio-informatics-jobs",
        "label": "Bio-Informatics Jobs-Diploma"
      },
      {
        "href": "/be-b-tech-electronics-communication-engineeringece-jobs",
        "label": "ECE Jobs"
      },
      {
        "href": "/bfa-fine-arts-jobs",
        "label": "Fine Arts Jobs-BFA"
      },
      {
        "href": "/be-b-tech-fashion-design-technology-jobs",
        "label": "Fashion Design Jobs"
      },
      {
        "href": "/mba-pgdm-international-marketing-jobs",
        "label": "International Marketing Jobs"
      },
      {
        "href": "/ma-accountancy-jobs",
        "label": "Accountancy Jobs-MA"
      },
      {
        "href": "/mba-pgdm-administration-jobs",
        "label": "Administration Jobs-MBA/PGDM"
      },
      {
        "href": "/mba-pgdm-advertising-mass-communication-jobs",
        "label": "Mass Communication Jobs"
      },
      {
        "href": "/llb-law-jobs",
        "label": "Law Jobs-LLB"
      },
      {
        "href": "/ca-accounts-jobs",
        "label": "Accounts Jobs-CA"
      },
      {
        "href": "/bsc-bioinformatics-jobs",
        "label": "BioInformatics Jobs-BSc"
      },
      {
        "href": "/bsc-agriculture-jobs",
        "label": "Agriculture Jobs-BSc"
      },
      {
        "href": "/mba-pgdm-general-management-jobs",
        "label": "General Management Jobs"
      },
      {
        "href": "/be-b-tech-agricultural-irrigation-engineering-jobs",
        "label": "Agriculture Engg Jobs"
      },
      {
        "href": "/bsc-geology-jobs",
        "label": "Geology Jobs-BSc"
      },
      {
        "href": "/bsc-physics-applied-physics-jobs",
        "label": "Physics Jobs (BSc)"
      },
      {
        "href": "/ba-politics-jobs",
        "label": "Politics Jobs-BA"
      },
      {
        "href": "/bsc-bio-chemistry-jobs",
        "label": "Bio-Chemistry Jobs-BSc"
      },
      {
        "href": "/ba-humanities-jobs",
        "label": "Humanities Jobs-BA"
      },
      {
        "href": "/b-fashiontech-apparel-production-jobs",
        "label": "Apparel Production Jobs"
      },
      {
        "href": "/diploma-marine-engineering-jobs",
        "label": "Marine Engineering Jobs"
      },
      {
        "href": "/ba-business-economics-jobs",
        "label": "Business Economics Jobs-BA"
      },
      {
        "href": "/mba-pgdm-human-resources-jobs",
        "label": "HR Jobs (MBA)"
      },
      {
        "href": "/be-b-tech-applied-electronics-jobs",
        "label": "Applied Electronics Jobs"
      },
      {
        "href": "/bsw-social-work-jobs",
        "label": "Social Work Jobs-BSW"
      },
      {
        "href": "/b-com-commerce-jobs",
        "label": "Commerce Jobs-B.Com"
      },
      {
        "href": "/bhm-hotel-management-jobs",
        "label": "Hotel Management Jobs-BHM"
      },
      {
        "href": "/be-b-tech-industrial-engineering-jobs",
        "label": "Industrial Engineering Jobs"
      },
      {
        "href": "/bsc-nursing-jobs",
        "label": "Nursing Jobs-BSc"
      }
    ]
  }
];
